import { render, staticRenderFns } from "./Mailing.vue?vue&type=template&id=56f25cc0&"
import script from "./Mailing.vue?vue&type=script&lang=js&"
export * from "./Mailing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports